import {
    IEmissionsOfEcaSeaAreas,
    IEmissionsOfOperationalPhases,
    IFleetCiiAlignment,
    IMsiEnvironmentalCredentials,
    IRollingAerValues,
    IVesselCiiAlignments,
    IVesselKeyMetricsDateBased,
    IVesselsEtsAndFuelEuEmissions,
    IVesselsMainEngineFuelConsumes
} from "./greenTypes";
import { authApiV2 } from "../../axiosWrapper";

export const getMsiEnvironmentalCredentialsByImoNumber = async (imoNumbers: number[]): Promise<IMsiEnvironmentalCredentials> => {
    const endpoint = `/msi-environmental-credentials`;
    try {
        const data = await authApiV2.post(endpoint, { imoNumbers: imoNumbers });
        return Promise.resolve(data.data as IMsiEnvironmentalCredentials);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getGreenSummaryByImoNumbers = async (imoNumbers: number[], startYearMonth: number, endYearMonth: number): Promise<IMsiEnvironmentalCredentials> => {
    const endpoint = `/green-summary`;
    try {
        const data = await authApiV2.post(endpoint, { imoNumbers: imoNumbers, startYearMonth, endYearMonth });
        return Promise.resolve(data.data as IMsiEnvironmentalCredentials);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getRollingAerValuesByImoNumber = async (imoNumber: number, startDate: string, endDate: string): Promise<IRollingAerValues[]> => {
    const endpoint = `/rolling-aer-values`;
    try {
        const data = await authApiV2.get(endpoint, { params: { imoNumber, startDate, endDate } });
        return Promise.resolve(data.data as IRollingAerValues[]);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getEmissionsOfEcaSeaAreasByImoNumber = async (imoNumber: number, startYearMonth: number, endYearMonth: number): Promise<IEmissionsOfEcaSeaAreas[]> => {
    const endpoint = `/emissions-of-eca-sea-areas`;
    try {
        const data = await authApiV2.get(endpoint, { params: { imoNumber, startYearMonth, endYearMonth } });
        return Promise.resolve(data.data as IEmissionsOfEcaSeaAreas[]);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getCohortEmissionsOfEcaSeaAreasByImoNumbers = async (imoNumbers: number[], startYearMonth: number, endYearMonth: number): Promise<IEmissionsOfEcaSeaAreas[]> => {
    const endpoint = `/cohort-emissions-of-eca-sea-areas`;
    try {
        const data = await authApiV2.post(endpoint, { imoNumbers: imoNumbers, startYearMonth, endYearMonth });
        return Promise.resolve(data.data as IEmissionsOfEcaSeaAreas[]);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getEmissionsOfOperationalPhasesByImoNumber = async (imoNumber: number, startYearMonth: number, endYearMonth: number): Promise<IEmissionsOfOperationalPhases[]> => {
    const endpoint = `/emissions-of-operational-phases`;
    try {
        const data = await authApiV2.get(endpoint, { params: { imoNumber, startYearMonth, endYearMonth } });
        return Promise.resolve(data.data as IEmissionsOfOperationalPhases[]);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getCohortEmissionsOfOperationalPhasesByImoNumbers = async (imoNumbers: number[], startYearMonth: number, endYearMonth: number): Promise<IEmissionsOfOperationalPhases[]> => {
    const endpoint = `/cohort-emissions-of-operational-phases`;
    try {
        const data = await authApiV2.post(endpoint, { imoNumbers: imoNumbers, startYearMonth, endYearMonth });
        return Promise.resolve(data.data as IEmissionsOfOperationalPhases[]);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVesselCiiAlignmentsByImoNumber = async (imoNumber: number, startYearMonth: number, endYearMonth: number): Promise<IVesselCiiAlignments[]> => {
    const endpoint = `/vessel-cii-alignments`;
    try {
        const data = await authApiV2.get(endpoint, { params: { imoNumber, startYearMonth, endYearMonth } });
        return Promise.resolve(data.data as IVesselCiiAlignments[]);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getFleetCiiAlignmentByImoNumbers = async (imoNumbers: number[], startYearMonth: number, endYearMonth: number): Promise<IFleetCiiAlignment> => {
    const endpoint = `/fleet-cii-alignments`;
    try {
        const data = await authApiV2.post(endpoint, { imoNumbers: imoNumbers, startYearMonth, endYearMonth });
        return Promise.resolve(data.data as IFleetCiiAlignment);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVesselsEtsAndFuelEuEmissionsByImoNumbers = async (imoNumbers: number[], startYearMonth: number, endYearMonth: number): Promise<IVesselsEtsAndFuelEuEmissions[]> => {
    const endpoint = `/vessels-ets-fueleu-emissions`;
    try {
        const data = await authApiV2.post(endpoint, { imoNumbers: imoNumbers, startYearMonth, endYearMonth });
        return Promise.resolve(data.data as IVesselsEtsAndFuelEuEmissions[]);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVesselsMainEngineFuelConsumesByImoNumbers = async (imoNumbers: number[], startYearMonth: number, endYearMonth: number): Promise<IVesselsMainEngineFuelConsumes[]> => {
    const endpoint = `/vessels-main-engine-fuel-consumes`;
    try {
        const data = await authApiV2.post(endpoint, { imoNumbers: imoNumbers, startYearMonth, endYearMonth });
        return Promise.resolve(data.data as IVesselsMainEngineFuelConsumes[]);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVesselKeyMetricsDateBasedByImoNumbers = async (imoNumbers: number[], startYearMonth: number, endYearMonth: number): Promise<IVesselKeyMetricsDateBased[]> => {
    const endpoint = `/vessel-key-metrics-date-based`;
    try {
        const data = await authApiV2.post(endpoint, { imoNumbers: imoNumbers, startYearMonth, endYearMonth });
        return Promise.resolve(data.data as IVesselKeyMetricsDateBased[]);
    } catch (err) {
        return Promise.reject(err);
    }
};